import React from 'react';
import cx from 'classnames';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { string, bool, func } from 'prop-types';

import veritoneLogo from 'images/veritone-logo-white.svg';
import styles from './styles/index.scss';

export default class AppBar extends React.Component {
  static propTypes = {
    title: string,
    closeButton: bool,
    onClose: func,
    className: string,
  };
  static defaultProps = {};

  render() {
    const barClasses = cx(
      styles.appBar,
      styles['appBar--short'],
      this.props.className
    );

    return (
      <Toolbar className={barClasses}>
        {this.props.title ? (
          <span className={styles['appBar--title']}>{this.props.title}</span>
        ) : (
          <img src={veritoneLogo} />
        )}
        {this.props.closeButton && (
          <div style={{ marginLeft: 'auto' }}>
            <IconButton
              onClick={this.props.onClose}
              style={{ fontSize: 'inherit' }}
            >
              <CloseIcon
                className={styles.closeIcon}
                data-test="app-bar-close-button"
              />
            </IconButton>
          </div>
        )}
      </Toolbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/AppBar/index.js